<ion-header role="none">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="onBackClick()" *ngIf="showReasonPage === false" attr.aria-label="{{ 'ARIA_LABEL_BACK' | translate }}">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="ion-text-center ion-padding-start ion-padding-end ion-padding-bottom">

        <ion-icon color="participant" id="icon-location" name="location-outline" aria-hidden="true"></ion-icon>

        <!-- <h3 id="page-title">Use your location</h3> -->
        <h3 id="page-title" role="heading" aria-level="1" [innerHTML]="'LOCATION_REQUIRED_HEADER' | translate"></h3>

        <div>

            <div *ngIf="showReasonPage === true">
                <!-- <h6><strong>rMove</strong> collects location data to record your trips, even when the app is closed or not in use.</h6>
                <h6>This allows rMove to display your trips on a map and to ask you questions about your travel.</h6> -->
                <h6 role="none" [innerHTML]="'LOCATION_REQUIRED_WHAT' | translate"></h6>
                <h6 role="none" [innerHTML]="'LOCATION_REQUIRED_WHY' | translate"></h6>

                <br />
                <img id="img-map" src="assets/imgs/location-map.svg" aria-hidden="true"/>
                <br />
            </div>

            <div *ngIf="showReasonPage === false">
                <!-- <h6>When prompted on the next screen, please <strong>'Always Allow'</strong> rMove to collect your location.</h6>S
                <h6>Note: if 'Always Allow' isn't shown as an option, rMove will prompt you to update your settings manually.</h6> -->
                <h6 role="none" [innerHTML]="'LOCATION_REQUIRED_ALWAYS_ALLOW' | translate"></h6>
                <h6 role="none" [innerHTML]="'LOCATION_REQUIRED_SET_MANUALLY' | translate"></h6>
            </div>


        </div>

        <div class="button-container ion-text-center">
            <ion-button
                class="emphasized-button"
                (click)="onProgressButtonClick()"
                [innerHTML]="(showReasonPage === true ? 'BUTTON_NEXT' : 'LOCATION_REQUIRED_BUTTON_GOT_IT') | translate"></ion-button>
        </div>
    </div>
</ion-content>
